import { render, staticRenderFns } from "./provinceSite.vue?vue&type=template&id=5dcbd2a4&scoped=true&"
import script from "./provinceSite.vue?vue&type=script&lang=js&"
export * from "./provinceSite.vue?vue&type=script&lang=js&"
import style0 from "./provinceSite.vue?vue&type=style&index=0&id=5dcbd2a4&scoped=true&lang=less&"
import style1 from "./provinceSite.vue?vue&type=style&index=1&id=5dcbd2a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcbd2a4",
  null
  
)

export default component.exports